import { render, staticRenderFns } from "./ClassicBloc.vue?vue&type=template&id=3db68de2&lang=pug&"
import script from "./ClassicBloc.vue?vue&type=script&lang=js&"
export * from "./ClassicBloc.vue?vue&type=script&lang=js&"
import style0 from "./ClassicBloc.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db68de2')) {
      api.createRecord('3db68de2', component.options)
    } else {
      api.reload('3db68de2', component.options)
    }
    module.hot.accept("./ClassicBloc.vue?vue&type=template&id=3db68de2&lang=pug&", function () {
      api.rerender('3db68de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/blocs/ClassicBloc.vue"
export default component.exports